import axios from 'axios'

class ReportCacheService {
  cache = {}

  /**
   * Primative in memory cache for data files that are loaded
   */
  async getContainerFile (containerId, fileName) {
    const cached = this.cache[`${containerId}-${fileName}`]
    if (cached) {
      return cached
    }
    const result = axios.get(`api/content/${containerId}/file/${fileName}`)
    this.cache[`${containerId}-${fileName}`] = result
    return result
  }
}

export const reportCacheService = new ReportCacheService()
